import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { FiCheckCircle, FiXCircle, FiArrowRight, FiShoppingBag } from 'react-icons/fi';
import useCartStore from '../store/useCartStore';

const CheckoutResult = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { clearCartStore } = useCartStore();

  const status = searchParams.get('status');
  const orderId = searchParams.get('orderId');
  const rawMessage = searchParams.get('message') || '';

  const isSuccess = status === 'success';

  useEffect(() => {
    if (isSuccess) {
      clearCartStore();
      localStorage.removeItem('guest_cart');
      localStorage.removeItem('mashow_cart_snapshot');
    }
  }, [isSuccess]);

  const getTurkishErrorMessage = (msg) => {
    if (!msg) return 'İşlem sırasında bir hata oluştu. Lütfen tekrar deneyiniz.';
    const decoded = decodeURIComponent(msg);
    const lower = decoded.toLowerCase();

    if (lower.includes('user gave up') || lower.includes('vazgecitdi') || lower.includes('iptal')) {
      return 'Ödeme işlemi 3D doğrulama adımında iptal edildi.';
    }
    if (lower.includes('insufficient') || lower.includes('yetersiz bakiye') || lower.includes('not sufficient')) {
      return 'Kartınızda yeterli bakiye bulunmamaktadır.';
    }
    if (lower.includes('declined') || lower.includes('reddedildi') || lower.includes('onaylanmadi')) {
      return 'İşlem bankanız tarafından reddedildi. Lütfen kart bilgilerinizi ve limitinizi kontrol edin.';
    }
    if (lower.includes('expired') || lower.includes('suresi dolmus')) {
      return 'Kartınızın son kullanma tarihi geçmiştir.';
    }
    if (lower.includes('invalid card') || lower.includes('gecersiz kart')) {
      return 'Girdiğiniz kart numarası geçersizdir.';
    }
    if (lower.includes('cvv') || lower.includes('cvc')) {
      return 'Girdiğiniz güvenlik kodu (CVV) hatalıdır.';
    }
    if (lower.includes('sistem hatasi') || lower.includes('system error')) {
      return 'Banka sistemiyle iletişim kurulurken bir hata oluştu. Lütfen tekrar deneyiniz.';
    }
    return decoded;
  };

  const errorMessage = getTurkishErrorMessage(rawMessage);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-12">
      <div className="max-w-md w-full bg-white rounded-2xl p-8 border border-gray-100 shadow-xl text-center space-y-6 animate-fadeIn">
        
        {isSuccess ? (
          <>
            <div className="w-20 h-20 bg-emerald-50 text-emerald-600 rounded-full flex items-center justify-center mx-auto text-4xl animate-bounce">
              <FiCheckCircle />
            </div>
            <div>
              <span className="text-xs font-bold tracking-widest text-[#45b59c] uppercase">GARANTİ 3D POS İŞLEMİ BAŞARILI</span>
              <h1 className="font-serif text-3xl text-gray-900 font-light tracking-wide mt-2">Ödemeniz Alındı!</h1>
              <p className="text-xs text-gray-500 font-light mt-2 leading-relaxed">
                Siparişiniz Garanti BBVA Sanal POS 3D Secure sistemi tarafından başarıyla onaylandı. Siparişinizi hesabınızdan takip edebilirsiniz.
              </p>
            </div>

            <div className="pt-4 space-y-3">
              <button
                type="button"
                onClick={() => navigate(orderId ? `/account/orders/${orderId}` : '/account/orders')}
                className="w-full bg-gray-900 text-white py-3.5 rounded-xl text-xs font-bold uppercase tracking-wider hover:bg-gray-800 transition-all flex items-center justify-center gap-2 shadow-md"
              >
                <FiShoppingBag />
                <span>Siparişlerime Git</span>
              </button>
              <button
                type="button"
                onClick={() => navigate('/')}
                className="w-full bg-gray-100 text-gray-700 py-3.5 rounded-xl text-xs font-bold uppercase tracking-wider hover:bg-gray-200 transition-all"
              >
                Alışverişe Devam Et
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="w-20 h-20 bg-red-50 text-red-600 rounded-full flex items-center justify-center mx-auto text-4xl">
              <FiXCircle />
            </div>
            <div>
              <span className="text-xs font-bold tracking-widest text-red-500 uppercase">ÖDEME ONAYLANMADI</span>
              <h1 className="font-serif text-3xl text-gray-900 font-light tracking-wide mt-2">İşlem Başarısız</h1>
              <p className="text-xs text-gray-700 font-medium mt-3 p-3.5 bg-red-50/80 rounded-xl border border-red-100/80 leading-relaxed">
                {errorMessage}
              </p>
            </div>

            <div className="pt-4 space-y-3">
              <button
                type="button"
                onClick={() => navigate('/checkout')}
                className="w-full bg-gray-900 text-white py-3.5 rounded-xl text-xs font-bold uppercase tracking-wider hover:bg-gray-800 transition-all flex items-center justify-center gap-2 shadow-md"
              >
                <span>Tekrar Deneyin</span>
                <FiArrowRight />
              </button>
              <button
                type="button"
                onClick={() => navigate('/cart')}
                className="w-full bg-gray-100 text-gray-700 py-3.5 rounded-xl text-xs font-bold uppercase tracking-wider hover:bg-gray-200 transition-all"
              >
                Sepetime Dön
              </button>
            </div>
          </>
        )}

      </div>
    </div>
  );
};

export default CheckoutResult;
